import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTrips } from '../context/TripsContext';
import { LoadingView } from '@/components';

export const AppLoader = ():React.ReactNode => {
  const { firebaseUser, loading: authLoading } = useAuth();
  const { trips, loading: tripsLoading, fetchUserTrips, createTrip } = useTrips();
  const navigate = useNavigate();
  const [hasFetchedTrips, setHasFetchedTrips] = useState(false);

  useEffect(() => {
    if (authLoading) return;

    if (!firebaseUser) {
      navigate('/login');
      return;
    }

    // Fetch trips when user is authenticated
    const loadTrips = async () => {
      await fetchUserTrips();
      setHasFetchedTrips(true);
    };
    loadTrips();
  }, [firebaseUser, authLoading, fetchUserTrips, navigate]);

  useEffect(() => {
    // Wait for auth to be ready, trips to finish loading, AND for us to have fetched at least once
    if (authLoading || tripsLoading || !hasFetchedTrips) return;
    if (!firebaseUser) return;

    console.log("AppLoader: trips loaded", trips.length);

    const handleNavigation = async () => {
      if (trips.length === 0) {
        // Automatically create first trip
        try {
          const newTrip = await createTrip({
            nickname: 'Trip #1',
            currency: 'USD',
            total_budget: 0,
          });
          navigate(`/trip/${newTrip.short_id}`);
        } catch (error) {
          console.error('Error creating first trip:', error);
          navigate('/new-trip');
        }
      } else {
        // Navigate to last created trip (most recently created)
        const sortedTrips = [...trips].sort((a, b) => {
          const dateA = new Date(a.created_at || 0).getTime();
          const dateB = new Date(b.created_at || 0).getTime();
          return dateB - dateA; // Most recent first
        });
        navigate(`/trip/${sortedTrips[0].short_id}`);
      }
    };

    handleNavigation();
  }, [firebaseUser, authLoading, tripsLoading, hasFetchedTrips, trips, navigate, createTrip]);

  return (
    <LoadingView/>
  )
}